<template>
  <div class="header">
        <div class="wid1003">
        	<div class="sign">
	        	<div class="theTopLeft" v-if="member.username">
              &nbsp;欢迎您：{{member.username}}&emsp;&emsp;<a :href="memberIndexUrl">用户中心</a>&emsp;<a :href="logoutUrl">退出</a>
	        	</div>
            <div class="theTopLeft" v-else-if="!member.username">
              &nbsp;您好，您还没有登录！ <a :href="registerUrl">免费注册</a>&nbsp;|&nbsp;<a :href="loginUrl">账号登录</a>&nbsp;|&nbsp;<a :href="forgotPasswordUrl" target="_blank">忘记密码</a>
	        	</div>
                <div class="theTopRight">
                   <a @click="setHomePage(this)" href="javascript:void(0)">设为首页</a>&nbsp;|&nbsp;<a @click="addFavorite" href="javascript:void(0)">加入收藏</a>&nbsp;|&nbsp;<a :href="aboutUrl">联系我们</a>&nbsp;
                </div>
             </div>
            <div class="logo">
	           	<div style="font-size:26px;height:80px;float:left;width:650px;">
	                <p >上海公立医疗机构（部分）药品集中议价采购联盟服务网</p>
	            </div>
            	<div style="font-size:14px;height:80px;float:right;width:300px;">
            		<ul>
	            		<li><img :src="logoUrl"/></li>
	            		<li style="line-height:0;margin-left:80px; ">服务热线：021-62051086</li>
            		</ul>
            	</div>
             </div>
            <div class="tel1"></div>
            <div class="clear"></div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'headerView',
    data() {
      return {
        logoUrl:'',
        loginUrl: process.env.VUE_APP_API_URL,
        registerUrl: '',
        aboutUrl: '',
        member: '',
        forgotPasswordUrl: '',
        logoutUrl: process.env.VUE_APP_API_URL + 'logout.jspx',
        memberIndexUrl: process.env.VUE_APP_API_URL + 'myaccount',
        logoutState: false,
      }
    },
    created() {
      this.logoUrl = process.env.VUE_APP_API_URL + 'r/cms/yjlogo.png';
      this.aboutUrl = process.env.VUE_APP_API_URL + 'member/contect.jspx';
      this.registerUrl = process.env.VUE_APP_API_URL + 'member/register';
      this.forgotPasswordUrl = process.env.VUE_APP_API_URL + 'member/forgot';
      this.handleLogout();
      if(-1 == this.$route.path.indexOf('member')){
        if(-1 == this.$route.path.indexOf('register')){
          this.getMember();
        }
      }
    },
    methods: {
      getMember(){
        this.$api.dashboardApi.getMember().then(response => {
          if(response.status === 200){
            if(200 === response.data.code){
              this.member = response.data.data;
            }else if(403 === response.data.code){
              this.goLogin(response.data.msg);
            }else{
              this.$message({ message: response.data.data, offset: 200, type: 'error' });
            }
          }else{
            this.$message({ message: `账户登录失效！`, offset: 200, type: 'error' });
            setTimeout(() => {
              this.goLogin();
            }, 1500);
          }
        }).catch(error => {
          console.error(error);
        });
      },
      handleLogout(){
        if(-1 < this.$route.path.indexOf('useraction/dashboard')){
          this.logoutState = true;
        }
      },
      setHomePage(othis){
        try{
          othis.style.behavior = 'url(#default#homepage)';
          othis.setHomePage(window.location.href);
        }catch(e) {
          if(window.netscape){
            try{
              netscape.security.PrivilegeManager.enablePrivilege("UniversalXPConnect");
            }catch(e){
              alert("此操作被浏览器拒绝！\n请在浏览器地址栏输入“about:config”并回车\n然后将 [signed.applets.codebase_principal_support]的值设置为'true',双击即可。");
            }
            var prefs = Components.classes['@mozilla.org/preferences-service;1'].getService(Components.interfaces.nsIPrefBranch);
            prefs.setCharPref('browser.startup.homepage', window.location);
          }
        }
      },
      addFavorite(){
        let surl = window.location, stitle = document.title;
        try{
          window.external.addFavorite(surl, stitle);
        }catch(e){
          try{
            window.sidebar.addPanel(stitle, surl, "");
          }catch (e){
            alert("加入收藏失败，请使用Ctrl+D进行添加");
          }
        }
      },
      goLogin(msg) {
        setTimeout(() => {
          this.submitButtonLoading = false;
          this.$message({ message: msg, offset: 200, type: 'error' });
          window.location.href = process.env.VUE_APP_API_URL;
        }, 1500)
      }
    }
  }
</script>
<style>
  .header{
    height:106px;
  }
  @media screen and (max-width: 1000px)
  {
    .header { width:1212px; }
  }
  .logo{
    float: left;
    width:1000px;
    height:80px;
    margin: 0;
    text-align: left;
  }
  .logo ul{
    margin: 0;
    padding: 0;
  }
  .logo p {
    line-height: 80px;
    margin: 0;
    font-weight: revert;
  }
  .logout {
    font-size: 18px;

    color: #000;
    height: 80px;
    float: left;
    margin-top: 106px;
}
.logout a {
    cursor: pointer;
    position: relative;
    font-size: 12px;
    font-weight: 400;
    float: right;
    border: 1px solid #999;
    border-radius: 5px;
    padding: 3px;
    background: #999;
    color: #fff;
  }
  .wid1003 {
    width: 1003px;
    margin: 0 auto;
  }
  .theTopLeft {
    float: left;
  }
  .sign {
    height: 26px;
    line-height: 26px;
    text-align: right;
    color: #fff;
    font-weight: 450;
  }
  .sign a {
    color: #fff;
  }
  a:link, a:visited {
    text-decoration: none;
}
  .tel1 {
    float: right;
    margin: 0;
  }
  .clear {
    clear: both;
    height: 0;
    overflow: hidden;
  }
  ul, li {
    list-style: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderView.vue